import moment from 'moment-timezone';
import uuid from 'uuid/v1';

moment.tz.setDefault('CET');

export const DEFAULT_LANGUAGE = 'English';
export const AVAILABLE_LANGUAGES = ['English', 'Norwegian'];

export const ACTIVITIES_TAB = 1;

export const SCHEDULE_DAYS = {
  Mon: false,
  Tue: false,
  Wed: false,
  Thu: false,
  Fri: false,
  Sat: false,
  Sun: false
};

export const SCHEDULE_SECTION = {
  dateNoTime: 0,
  dateTime: 1,
  pass: 2
};

export const CATEGORIES = [
  'Adult',
  'Children',
  'Senior',
  'Teen',
  'Infant',
  'Universal'
];

export const PLATFORMS = ['Expedia', 'Trekksoft', 'BOOKING'];

export const INITIAL_ACTIVITY_FORM_DATA = {
  generalForm: {
    activityType: 'Open',
    productCode: '',
    coverPhoto: {}
  },
  descriptionForm: {},
  scheduleDateForm: {
    availability: {
      startDate: moment(),
      endDate: null
    },
    days: SCHEDULE_DAYS,
    cutoffPeriod: 0,
    cutoffPeriodTimeType: 'days'
  },
  scheduleDateTimeForm: {
    availability: {
      startDate: moment(),
      endDate: null
    },
    cutoffPeriod: 0,
    cutoffPeriodTimeType: 'minutes',
    daysArray: [
      {
        id: uuid(),
        days: SCHEDULE_DAYS,
        startTimeAndDuration: [
          {
            startTime: moment(),
            duration: null,
            timeType: 'hours'
          }
        ]
      }
    ]
  },
  schedulePassForm: {
    availability: {
      startDate: moment(),
      endDate: null
    }
  },
  pricesFixedForm: {
    days: []
  },
  pricesDailyForm: {
    days: []
  },
  pricesEqualForm: {
    categories: [
      {
        participant: 'Adult',
        USD: '0',
        EUR: '0',
        NOK: '0'
      }
    ]
  },
  pricesDailyScheduleForm: {
    daysArray: []
  },
  activityFuturePricesForm :{
   futureRatePlanIds: {},
  },
  addOnsForm: {
    addOns: []
  },
  // mandatoryFeesForm: {
  //   mandatoryFees: []
  // },
  relatedAccommodationsForm: {
    relatedAccommodations: []
  },
  integrationForm: {
    integrations: []
  }
};

export const ACTIVITY_FORMS_ORDER = [
  'generalForm',
  'descriptionForm',
  {
    0: 'scheduleDateForm',
    1: 'scheduleDateTimeForm',
    2: 'schedulePassForm'
  },
  {
    0: {
      0: 'pricesFixedForm',
      1: 'pricesDailyForm',
      2: 'pricesEqualForm'
    },
    1: {
      0: 'pricesFixedForm',
      1: 'pricesDailyScheduleForm',
      2: 'pricesEqualForm'
    },
    2: {
      0: 'pricesFixedForm',
      1: 'pricesEqualForm'
    }
  },
  'activityFuturePricesForm',
  'addOnsForm',
  'relatedAccommodationsForm',
  'integrationForm'
];

export const ACTIVITY_FORMS_NUMBERS = {
  generalForm: 0,
  descriptionForm: 1,
  scheduleForm: 2,
  pricesForm: 3,
  activityFuturePricesForm :4,
  addOnsForm: 5,
  relatedAccommodationsForm: 6, 
  integrationForm: 7,
  
};

export const ACTIVITY_SCHEDULE_FORMS_NUMBERS = {
  scheduleDateForm: 0,
  scheduleDateTimeForm: 1,
  schedulePassForm: 2
};

export const ACTIVITY_PRICES_FORMS_NUMBERS = {
  0: {
    pricesFixedForm: 0,
    pricesDailyForm: 1,
    pricesEqualForm: 2
  },
  1: {
    pricesFixedForm: 0,
    pricesDailyScheduleForm: 1,
    pricesEqualForm: 2
  },
  2: {
    pricesFixedForm: 0,
    pricesEqualForm: 1
  }
};
